<template>
  <div>
    <el-form-item :required="required">
      <template #label>{{ codeEnum.code }}</template>
      <el-row :gutter="gutter">
        <el-col :span="span1" class="col_positon">
          <el-form-item ref="elFormItem" :prop="prop" :rules="rules">
            <el-input
              v-model="localInputVal"
              class="left_input"
              :disabled="showList || localDisabled"
              :class="[showList ? 'multiple' : '']"
              @input="handleLocalInputVal"
              @blur="handleBlur"
            />
            <template #error="{ error }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="error"
                placement="bottom"
              >
                <div class="el-form-item__error">{{ error }}</div>
              </el-tooltip>
            </template>
            <div
              v-if="!localDisabled"
              class="more_box flex_center flex_center_align"
              @click="selectDep"
            >
              <svg-icon icon-class="select"></svg-icon>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="span2">
          <el-input
            v-model="localInputName"
            class="right_input"
            :class="[showList ? 'multiple' : '']"
            disabled
          />
          <el-popover v-show="showList" placement="bottom" trigger="click">
            <el-table :data="list" border stripe max-height="300">
              <el-table-column
                width="80"
                property="itmcd"
                header-align="center"
                label="商品CD"
              ></el-table-column>
              <el-table-column
                width="300"
                header-align="center"
                property="itmnm"
                label="商品名"
              ></el-table-column>
            </el-table>
            <div
              slot="reference"
              class="more_box flex_center flex_center_align more_change_box"
            >
              <div class="inner_box flex_center flex_center_align">
                <svg-icon :icon-class="'sel'"></svg-icon>
              </div>
            </div>
          </el-popover>
        </el-col>
      </el-row>
    </el-form-item>
    <MitmbaspDialog
      ref="dialog"
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      :multi-select="multiSelect"
      :code-field="codeField"
      :name-field="nameField"
      @get-selection="getSelection"
      @opened="dialogOpened"
    />
  </div>
</template>

<script>
  import { getmitmbasp } from '@/api/mitmbasp'
  import mixComponent from '@/utils/mixComponent'
  export default {
    // 商品
    name: 'Mitmbasp',
    mixins: [mixComponent],
    props: {
      codeEnum: {
        type: Object,
        default: () => ({
          code: '商品',
          value: '商品CD',
          text: '商品選択',
          table: '商品マスタ',
        }),
      },
    },
    created() {
      this.codeField = 'itmcd'
      this.nameField = 'itmnm'
    },
    methods: {
      async getOne(val) {
        return getmitmbasp(val)
      },
      initParams() {
        if (this.getParams) {
          let cond = this.getParams()
          let queryForm = this.$refs['dialog'].queryForm
          queryForm.jtwrkkbList = cond.entrustedWork
          //this.$refs['dialog'].onSearch()
        }
      },
      dialogOpened() {
        this.$refs['dialog'].setEntrustedWork()
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/vab/styles/component.scss';
</style>
